import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ServiceUnavailableScreenService {
  readonly isServiceUnavailable = signal(false);

  showServiceUnavailable(): void {
    this.isServiceUnavailable.set(true);
  }

  hideServiceUnavailable(): void {
    this.isServiceUnavailable.set(false);
  }

  isServiceUnavailableError(error: HttpErrorResponse): boolean {
    return error.status === 503;
  }
}
